import { CHARGER_STATUS, CHARGER_STATUS_SILENT, FETCH_CHARGER_STATUS_WIDGETS, SET_SELECTED_STATUSES, TOGGLE_LIVE_MODE, RESET_LIVE_MODE, PUBNUB_STATUS_UPDATE } from 'actions/chargerStatus';

// Map charger_status value → widget count key in state
const STATUS_COUNT_KEY = {
  'Available':              'availableCount',
  'In Use':                 'inuse',
  'Unavailable':            'unavailableCount',
  'Charging':               'chargingCount',
  'Preparing':              'preparingCount',
  'Finishing':              'finishingCount',
  'Faulted':                'faultedCount',
  'PowerLoss':              'PowerLossCount',
  'underMaintenance':       'underMaintenance',
  'comingSoon':             'comingSoon',
  'Emergency stop pressed': 'emergencyStopCount',
};

const initialState = {
  isLoading: false,
  isSilentLoading: false,
  chargerStatus: [],
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
  selectedStatuses: [],
  isLiveMode: false,
  lastPubNubEvent: null,
};

const chargerStatusReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case CHARGER_STATUS.REQUEST: {
      return { ...state, isLoading: true };
    }
    // Silent fetch — no skeleton, just swap data when ready
    case CHARGER_STATUS_SILENT.REQUEST: {
      return { ...state, isSilentLoading: true };
    }
    case CHARGER_STATUS_SILENT.SUCCESS: {
      return {
        ...state,
        isSilentLoading: false,
        chargerStatus: payload.results,
        page: payload.page,
        limit: payload.limit,
        totalPages: payload.totalPages,
        total: payload.totalResults,
      };
    }
    case CHARGER_STATUS_SILENT.FAIL: {
      return { ...state, isSilentLoading: false };
    }

    case CHARGER_STATUS.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        chargerStatus: payload.results,
        page: payload.page,
        limit: payload.limit,
        totalPages: payload.totalPages,
        total: payload.totalResults,
      };
    }

    case FETCH_CHARGER_STATUS_WIDGETS.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        totalChargers: payload.data?.totalChargers,
        inuse: payload.data?.inUseCount,
        PowerLossCount: payload.data?.powerLossCount,
        availableCount: payload.data?.availableCount,
        chargingCount: payload.data?.chargingCount,
        draftCount: payload.data?.draftCount,
        faultedCount: payload.data?.faultedCount,
        finishingCount: payload.data?.finishingCount,
        preparingCount: payload.data?.preparingCount,
        totalChargersPlugs: payload.data?.totalChargersPlugs,
        unavailableCount: payload.data?.unavailableCount,
        emergencyStopCount: payload.data?.emergencyStopCount,
        underVoltage: payload.data?.underVoltage,
        overVoltage: payload.data?.overVoltage,
        underMaintenance: payload.data?.underMaintenance,
        comingSoon: payload.data?.comingSoon,
      };
    }

    case CHARGER_STATUS.FAIL: {
      return { ...state, isLoading: false };
    }

    case SET_SELECTED_STATUSES: {
      return { ...state, selectedStatuses: payload };
    }
    case TOGGLE_LIVE_MODE: {
      const newLiveMode = payload !== undefined ? payload : !state.isLiveMode;
      return { ...state, isLiveMode: newLiveMode };
    }
    case RESET_LIVE_MODE: {
      return { ...state, isLiveMode: false };
    }

    case PUBNUB_STATUS_UPDATE: {
      const incomingId = payload._id || payload.id || payload.charger_id;
      if (!incomingId) return { ...state };

      const isMatch = (item) =>
        (item._id || item.id) === incomingId || item.charger_id === incomingId;

      const existing = state.chargerStatus.find(isMatch);
      if (!existing) return { ...state };

      const oldStatus = existing.charger_status;
      const newStatus = payload.charger_status;
      const merged = { ...existing, ...payload, updatedAt: payload.updatedAt || new Date().toISOString() };

      let countUpdates = {};
      if (oldStatus && newStatus && oldStatus !== newStatus) {
        const oldKey = STATUS_COUNT_KEY[oldStatus];
        const newKey = STATUS_COUNT_KEY[newStatus];
        if (oldKey) countUpdates[oldKey] = Math.max(0, (state[oldKey] || 0) - 1);
        if (newKey) countUpdates[newKey] = (state[newKey] || 0) + 1;
      }

      return {
        ...state,
        chargerStatus: [merged, ...state.chargerStatus.filter((item) => !isMatch(item))],
        lastPubNubEvent: payload,
        ...countUpdates,
      };
    }

    default:
      return { ...state };
  }
};
export default chargerStatusReducer;
